import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import type { BackendConnectivityStatus } from "@/lib/backend-connectivity";

interface BackendConnectivityBannerProps {
  status: BackendConnectivityStatus;
  onRetry: () => void;
}

export function BackendConnectivityBanner({
  status,
  onRetry,
}: BackendConnectivityBannerProps) {
  const { t } = useTranslation();
  if (status !== "offline") return null;

  return (
    <div
      className="flex shrink-0 items-center justify-center gap-2 border-b border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-900 dark:text-amber-200"
      role="status"
      data-testid="backend-connectivity-banner"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden="true" />
      <span>{t("common:connectivity.backendUnreachable")}</span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 px-2 text-xs"
        onClick={onRetry}
      >
        {t("common:connectivity.retryNow")}
      </Button>
    </div>
  );
}
